import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ScnackbarData, SnackbarStyles, ToastService } from '../../../../commons/toast.service';
import { NuevaTarea, AccionTarea } from '../../../../models/Tarea';
import { TareaService } from '../../../../services/tarea.service';
import { AvanceComponent } from '../avance/avance.component';
import { MatInputModule } from '@angular/material/input';
import { UtilService } from '../../../../services/util.service';

@Component({
    selector: 'app-finalizar',
    imports: [
        MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent,
        MatButtonModule, MatIconModule,
        FormsModule, ReactiveFormsModule, MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule
    ],
    templateUrl: './finalizar.component.html',
    styleUrl: './finalizar.component.scss'
})
export class FinalizarComponent {
  readonly dialogRef = inject(MatDialogRef<AvanceComponent>);
  readonly data = inject<NuevaTarea>(MAT_DIALOG_DATA);
  utilService = inject(UtilService)
  nuevaTarea: NuevaTarea

  finalizarForm = new FormGroup({
    porcentaje: new FormControl("100", {
      validators: [Validators.required]
    }),
    comentario: new FormControl("", {
      validators: [Validators.required]
    })
  })

  fetchingFinalizarTarea = false

  snackbarData: ScnackbarData = {}

  constructor(
    private tareaService: TareaService,
    private toast: ToastService
  ) {
    this.nuevaTarea = structuredClone(this.data)
  }

  onSubmitForm() {
    this.fetchingFinalizarTarea = true
    const formControls = this.finalizarForm.controls
    const accionTareas: AccionTarea[] = [
      {
        id: this.nuevaTarea.id,
        idParticipante: this.nuevaTarea.idAsignado,
        comentario: formControls.comentario.value!,
        avance: parseInt(formControls.porcentaje.value!),
        fechaExpira: this.nuevaTarea.fechaExpira
      }
    ]
    this.tareaService.finalizarTarea(accionTareas).subscribe({
      next: (_) => {
        this.snackbarData.message = "Tarea finalizada"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.fetchingFinalizarTarea = false
        this.toast.show(this.snackbarData)
        this.utilService.callTasks();
        this.dialogRef.close({ success: true })
      },
      error: (_) => {
        this.snackbarData.message = "Error finalizando tarea"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.fetchingFinalizarTarea = false
        this.toast.show(this.snackbarData)
        this.dialogRef.close({ success: false })
      }
    })
  }

}
